<mat-icon class="mat-18 position-absolute text-trans">policy</mat-icon>
<router-outlet></router-outlet>
